import TableLine from '@/molecules/TableLine';
import TabledContent from '@/molecules/TableLine/TableContent';
import { PRINTING_STATUS_LABEL } from 'constants/printing';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import { useTranslation } from 'react-i18next';

type Props = {
  closeModal: () => void;
};

const STATUS_DEFINITIONS = [
  {
    status: PRINTING_STATUS_LABEL.DRAFT, // draft
    description: 'modal.printing.definitions.DRAFT',
  },
  {
    status: PRINTING_STATUS_LABEL.TO_VERIFY, // toVerify & Card cardRegeneration
    description: 'modal.printing.definitions.TO_VERIFY',
  },
  {
    status: PRINTING_STATUS_LABEL.CONFIRMED, // confirmed
    description: 'modal.printing.definitions.CONFIRMED',
  },
  {
    status: PRINTING_STATUS_LABEL.INTEGRATED, // integrated
    description: 'modal.printing.definitions.INTEGRATED',
  },
  {
    status: PRINTING_STATUS_LABEL.SHIPPED, // shipped
    description: 'modal.printing.definitions.SHIPPED',
  },
  {
    status: PRINTING_STATUS_LABEL.INTEGRATION_ERROR, // integrationError
    description: 'modal.printing.definitions.INTEGRATION_ERROR',
  },
  {
    status: PRINTING_STATUS_LABEL.CANCELED, // shipped
    description: 'modal.printing.definitions.CANCELED',
  },
];

const PrintingStatus = ({ closeModal }: Props) => {
  const { t } = useTranslation();

  return (
    <ModalClassicLayout
      closeModal={closeModal}
      submitLabel={t('understood')}
      title={t('modal.printing.definitions.cta')}
    >
      <div className="flex flex-col gap-2">
        {STATUS_DEFINITIONS.map((status) => (
          <TableLine key={status.status} label={t(status.status)}>
            <TabledContent price={t(status.description)} />
          </TableLine>
        ))}
      </div>
    </ModalClassicLayout>
  );
};

export default PrintingStatus;
